import React from "react";
import { InputAntd } from "./styles";

export default function AntdInput({ ...props }) {
	return <InputAntd {...props} />;
}
